import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from '../common.js'

export function postPhoneNumber(options) {
  return request.postJson(
    {
      url: appendApiUrl('/draw/recharge'),
      data: { ...deleteEmpty(options) },
    },
    true
  )
}

export function queryLuckyDrawResult(options, str) {
  if (str === 'mock') {
    return new Promise((resolve, reject) => {
      return reject({})
    })
  } else {
    return request.postJson(
      {
        url: appendApiUrl('/activity/draw/play'),
        data: { ...deleteEmpty(options) },
      },
      {
        showLoading: false,
        showErrorToast: false,
      }
    )
  }
}

/* 查询抽奖资格剩余次数 */
export function queryRemainingShots(params) {
  return request.postJson(
    {
      url: appendApiUrl('/activity/draw/query/count'),
      data: { ...deleteEmpty(params) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}

export function queryPrizeList(options) {
  return request.postJson(
    {
      url: appendApiUrl('/activity/draw/awards'),
      data: { ...deleteEmpty(options) },
    },
    {
      showLoading: false,
      showErrorToast: false,
    }
  )
}
